// UI strings for the week's grammar read twice (app/src/grammartwice/, Axel 2026-10-14): Tänään's door
// "Kertaa viikon kielioppi" from day 4 of the lesson week, its page (the lesson's Kielioppi topics again, then a
// few rule questions from the lesson's check) and the week page's "Kielioppi luettu 1/2".
// Style: docs/FINNISH-STYLE.md (sinä, no jargon, only actionable text).
import { defineArea } from '../area';

const questionsFi = (n: number) => (n === 1 ? '1 kysymys' : `${n} kysymystä`);

export const grammarTwiceFi = {
  /** Tänään's door, the week ledger's link and the page's heading. */
  door: 'Kertaa viikon kielioppi',
  doorDetail: 'lue uudelleen ja vastaa kysymyksiin',
  /** The kicker over the page: "Oppitunti 9 · Kertaus". */
  kicker: (lesson: string) => `${lesson} · Kertaus`,
  /** The questions' part at the end of the page. */
  questionsH: 'Kysymykset',
  questions: questionsFi,
  start: 'Vastaa kysymyksiin',
  again: 'Vastaa uudelleen',
  /** A lesson whose check has no rule questions: the text alone, marked read. */
  noQuestions: 'Tässä kertauksessa ei ole kysymyksiä.',
  markRead: 'Merkitse luetuksi',
  /** The week page and the ledger: the first reading (Tunti) and the second. */
  count: (n: number) => `Kielioppi luettu ${n}/2`,
  mate: (name: string, n: number) => `${name} ${n}/2`,
  /** On the page, once the second reading is done. */
  done: 'Kielioppi luettu 2/2.',
};

export const grammarTwiceEn: typeof grammarTwiceFi = {
  door: 'Review the week’s grammar',
  doorDetail: 'read it again and answer the questions',
  kicker: (lesson) => `${lesson} · Review`,
  questionsH: 'Questions',
  questions: (n) => (n === 1 ? '1 question' : `${n} questions`),
  start: 'Answer the questions',
  again: 'Answer again',
  noQuestions: 'This review has no questions.',
  markRead: 'Mark as read',
  count: (n) => `Grammar read ${n}/2`,
  mate: (name, n) => `${name} ${n}/2`,
  done: 'Grammar read 2/2.',
};

// Messages.grammarTwice (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('grammarTwice', grammarTwiceFi, grammarTwiceEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof grammarTwiceFi> {}
}
